import { render, staticRenderFns } from "./OrgInfoSetting.vue?vue&type=template&id=487776b6&scoped=true&"
import script from "./OrgInfoSetting.vue?vue&type=script&lang=ts&"
export * from "./OrgInfoSetting.vue?vue&type=script&lang=ts&"
import style0 from "./OrgInfoSetting.vue?vue&type=style&index=0&id=487776b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487776b6",
  null
  
)

export default component.exports